import {
    CLAPI
} from '../clchart/cl.api.js'
import * as DATAS from '../datas/transdata.js'


export const ioarea_fields = 'msecstamp,minp,maxp,obidm,ibidm,oaskm,iaskm'
export const iodate_fields = 'msec,agop,open,maxp,minp,newp,sumv,summ,obidm,ibidm,oaskm,iaskm'

// export const iominute_fields = 'msec,open,maxp,minp,newp,sumv,summ,oaskm,iaskm,obidm,ibidm'
export const ftrend_fields = 'msecstamp,midp,stoped,near_upsf,near_dnsf,mood_upbf,mood_dnbf,mood_sumf,emny_summ,ep_seejgf,ep_seeshf,ep_seerzf'

// 字段定义
export const FIELD_KBAR = {
    date: 0,
    agop: 1,
    open: 2,
    maxp: 3,
    minp: 4,
    newp: 5,
    sumv: 6,
    summ: 7,
    avgp: 8, // 60日均线
    clr: 9,
    right: 10,
}

export function IodateToAvgKbar(indata, keyInfo, days) {
    let kbars = []
    days = days || 60
    // for (let index = indata.datas.length - 10; index < indata.datas.length; index++) {
    //     console.log(keyInfo.frights[index][0], keyInfo.frights[index][1]);
    // }
    let agoright = 0
    for (let index = 0; index < indata.datas.length; index++) {
        let right = '0'
        let clr = 'red'
        if (parseFloat(CLAPI.getData(indata, 'open', index)) > parseFloat(CLAPI.getData(indata, 'newp', index))) {
            clr = 'green'
        }
        let sumv = 0
        let summ = 0
        let avgp = CLAPI.getData(indata, 'newp', index)
        for (let di = index, ds = 0; di >= 0 && ds < days; di--, ds++) {
            sumv += CLAPI.getData(indata, 'sumv', index - ds)
            summ += CLAPI.getData(indata, 'summ', index - ds)
        }
        avgp = summ / sumv
        // if (index > indata.datas.length - 10)
        // console.log(CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)), right, keyInfo.frights[index][1], agoright);
        if (keyInfo.frights[index] !== undefined) {
            if (index > 0) {
                if (agoright !== keyInfo.frights[index][1]) {
                    right = 'scir'
                }
            }
            agoright = keyInfo.frights[index][1]
        }
        kbars.push(
            [CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)),
                CLAPI.getData(indata, 'agop', index),
                CLAPI.getData(indata, 'open', index),
                CLAPI.getData(indata, 'maxp', index),
                CLAPI.getData(indata, 'minp', index),
                CLAPI.getData(indata, 'newp', index),
                CLAPI.getData(indata, 'sumv', index),
                CLAPI.getData(indata, 'summ', index),
                avgp,
                clr,
                right,
            ])
    }
    return {
        fields: FIELD_KBAR,
        datas: kbars
    }
}

export const FIELD_KBAR_SNUMS = {
    date: 0,
    nums: 1,
}
export function SignalToNums(indata, kbars) {
    let snums = []
    let kindex = 0
    let sindex = 0
    let signal = {}
    for (let sindex = 0; sindex < indata.datas.length; sindex++) {
        const sdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msecstamp', sindex))
        if (signal[sdate] == undefined) {
            signal[sdate] = { nums : CLAPI.getData(indata, 'signal', sindex)}
        }
        else {
            signal[sdate].nums += CLAPI.getData(indata, 'signal', sindex)
        }
    }
    for (let kindex = 0; kindex < kbars.datas.length; kindex++) {
        const kdate = CLAPI.getData(kbars, 'date', kindex)     
        if (signal[kdate] == undefined) {
            snums.push([kdate, 0])
        }
        else {
            snums.push([kdate, signal[kdate].nums])
        }
    }
    return {
        fields: FIELD_KBAR_SNUMS,
        datas: snums
    }
}

export const FIELD_KBAR_RATE = {
    date: 0,
    rate: 1,
}
export function IodateToRate(indata) {
    let kbars = []
    for (let index = 0; index < indata.datas.length; index++) {
        kbars.push(
            [CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index)),
                (CLAPI.getData(indata, 'newp', index) - CLAPI.getData(indata, 'agop', index)) / CLAPI.getData(indata, 'agop', index) * 100.0,
            ])
    }
    return {
        fields: FIELD_KBAR_RATE,
        datas: kbars
    }
}
// {static  frights}
export function KbarExright(indata, keyInfo, rightMode, days) {
    let kbars = []
    days = days || 60
    rightMode = rightMode || 'forword'
    console.log(keyInfo);
    for (let index = 0; index < indata.datas.length; index++) {
        // console.log(CLAPI.getData(indata, 'date', index), keyInfo.frights[index][0], keyInfo.frights[index][1]);
        let fr = keyInfo.frights[index]
        if (index >= keyInfo.frights.length) {
            fr = [0, 1.0]
        }
        kbars.push(
            [CLAPI.getData(indata, 'date', index),
                CLAPI.getData(indata, 'agop', index) * fr[1],
                CLAPI.getData(indata, 'open', index) * fr[1],
                CLAPI.getData(indata, 'maxp', index) * fr[1],
                CLAPI.getData(indata, 'minp', index) * fr[1],
                CLAPI.getData(indata, 'newp', index) * fr[1],
                CLAPI.getData(indata, 'sumv', index) / fr[1],
                CLAPI.getData(indata, 'summ', index),
                0,
                CLAPI.getData(indata, 'clr', index),
                CLAPI.getData(indata, 'right', index) !== '0' ? 'fcir' : '0',
            ])
        let sumv = 0
        let summ = 0
        for (let di = kbars.length - 1, ds = 0; di >= 0 && ds < days; di--, ds++) {
            sumv += kbars[di][6]
            summ += kbars[di][7]
        }
        kbars.at(-1)[8] = summ / sumv
    }
    return {
        fields: FIELD_KBAR,
        datas: kbars
    }
}

const FIELD_DDTJ = {
    date: 0,
    cur_summ: 1,
    big_askm: 2,
    big_bidm: 3,
    cur_bigm: 4,
    big_askr: 5,
    big_bidr: 6,
    cur_bigr: 7,
    sum_bigr5: 8,
}

export function IodateToDDTJ(indata, axisXinfo) {
    let outs = []    
    let kbarindex = 0
    for (let index = 0; index < indata.datas.length; index++) {
        const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
        while (curdate > axisXinfo[kbarindex]) {
            outs.unshift([axisXinfo[kbarindex], 0, 0, 0, 0, 0])
            // console.log(curdate, axisXinfo[kbarindex]);
            kbarindex++
        }
        if (curdate < axisXinfo[kbarindex]) {
            // console.log(curdate, axisXinfo[kbarindex]);
            continue
        }
        let big_askm = 0
        let big_bidm = 0
        for (let mi = 3; mi < 8; mi++) {
            big_askm += CLAPI.getData(indata, 'oaskm' + mi.toString(), index)
            big_askm += 0.5 * CLAPI.getData(indata, 'iaskm' + mi.toString(), index)
            big_bidm += CLAPI.getData(indata, 'obidm' + mi.toString(), index)
            big_bidm += 0.5 * CLAPI.getData(indata, 'ibidm' + mi.toString(), index)
        }
        const cur_bigm = big_bidm - big_askm
        const cur_summ = CLAPI.getData(indata, 'summ', index)

        outs.push(
            [curdate,
                cur_summ,
                big_askm,
                big_bidm,
                cur_bigm,
                big_askm / cur_summ,
                big_bidm / cur_summ,
                cur_bigm / cur_summ,
                0,
            ])
        let sum_bigm5 = 0
        let sum_summ5 = 0
        for (let bri = outs.length - 1, nums = 0; nums < 5 && bri >= 0; bri--, nums++) {
            sum_bigm5 += outs[bri][4]
            sum_summ5 += outs[bri][1]
        }
        outs[outs.length - 1][8] = sum_bigm5 / sum_summ5
        kbarindex++
    }
    return {
        fields: FIELD_DDTJ,
        datas: outs
    }
}
const FIELD_SHCC = {
    date: 0,
    xvolr: 1,
    yvolr: 2,
    zvolr: 3,
    smveer: 4,
    swveer: 5,
    dvolr: 6,
    xsvrchg: 7,
    ysvrchg: 8,
    zsvrchg: 9,
    dsvrchg: 10,
}
export function chip3ToSHCC(indata, axisXinfo) {
    let outs = []
    
    let kbarindex = 0
    for (let index = 0; index < indata.datas.length; index++) {
        const curdate = CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msec', index))
        while (curdate > axisXinfo[kbarindex]) {
            outs.unshift([axisXinfo[kbarindex], 0, 0, 0, 0, 0])
            // console.log(curdate, axisXinfo[kbarindex]);
            kbarindex++
        }
        if (curdate < axisXinfo[kbarindex]) {
            // console.log(curdate, axisXinfo[kbarindex]);
            continue
        }
        let xvolr = CLAPI.getData(indata, 'sumchip_volr0', index)
        let xvchg = CLAPI.getData(indata, 'svrchg0', index)
        outs.push(
            [curdate,
                xvolr,
                CLAPI.getData(indata, 'sumchip_volr1', index),
                CLAPI.getData(indata, 'sumchip_volr2', index),
                CLAPI.getData(indata, 'smveer', index),
                CLAPI.getData(indata, 'swveer', index),
                (1.0 - xvolr),
                xvchg,
                CLAPI.getData(indata, 'svrchg1', index),
                CLAPI.getData(indata, 'svrchg2', index),
                -1 * xvchg,
            ])
        kbarindex++
    }
    return {
        fields: FIELD_SHCC,
        datas: outs
    }
}

const FIELD_IOAREA_KBAR = DATAS.fieldsToFieldsIndex('midp,shbidm,shaskm,shsumm,jgbidm,jgaskm,jgsumm')

export function ioareaToKV(indata) {
    // 排序
    indata.datas = CLAPI.Utils.sortNumberArray(indata.datas, 1, 'ascending')
    let areas = []
    let midp = 0
    let jgaskm = 0
    let jgbidm = 0
    let shaskm = 0
    let shbidm = 0

    for (let index = 0; index < indata.datas.length; index++) {
        const minp = CLAPI.getData(indata, 'minp', index)
        // console.log(minp);

        if (midp === 0) {
            midp = (minp + CLAPI.getData(indata, 'maxp', index)) / 2
        } else if (midp < minp) {
            areas.push([
                midp,
                shbidm,
                -1 * shaskm,
                shbidm - shaskm,
                jgbidm,
                -1 * jgaskm,
                jgbidm - jgaskm,
            ])
            midp = (minp + CLAPI.getData(indata, 'maxp', index)) / 2
            jgaskm = 0
            jgbidm = 0
            shaskm = 0
            shbidm = 0
        }
        for (let mi = 0; mi < 8; mi++) {
            if (mi < 3) {
                jgaskm += CLAPI.getData(indata, 'oaskm' + mi, index)
                jgaskm += CLAPI.getData(indata, 'iaskm' + mi, index)
                jgbidm += CLAPI.getData(indata, 'obidm' + mi, index)
                jgbidm += CLAPI.getData(indata, 'ibidm' + mi, index)
            } else {
                shaskm += CLAPI.getData(indata, 'oaskm' + mi, index)
                shaskm += CLAPI.getData(indata, 'iaskm' + mi, index)
                shbidm += CLAPI.getData(indata, 'obidm' + mi, index)
                shbidm += CLAPI.getData(indata, 'ibidm' + mi, index)
            }
        }
        if (index == indata.datas.length - 1) {
            areas.push([
                midp,
                shbidm,
                -1 * shaskm,
                shbidm - shaskm,
                jgbidm,
                -1 * jgaskm,
                jgbidm - jgaskm,
            ])
        }
    }

    return {
        fields: FIELD_IOAREA_KBAR,
        datas: areas
    }
}

const factor_fields = 'near_upsf,near_dnsf,mood_upbf,mood_dnbf,mood_sumf,emny_summ,ep_seejgf,ep_seeshf,ep_seerzf'
const ARRAY_FTREND = DATAS.strsToArray(factor_fields);
const FIELD_FTREND_KBAR = DATAS.fieldsToFieldsIndex('date,ep_seerjf,mood_subf,' + factor_fields)

export function TrendGetKV(indata) {
    let trends = []
    let trend = []
    for (let index = 0; index < indata.datas.length; index++) {
        const stoped = CLAPI.getData(indata, 'stoped', index)
        if (stoped !== 0) {
            continue
        }
        const ep_seerjf = DATAS.calcSubVal(CLAPI.getData(indata, 'ep_seejgf', index), CLAPI.getData(indata, 'ep_seeshf', index))
        const mood_subf = DATAS.calcSubVal(CLAPI.getData(indata, 'mood_upbf', index), CLAPI.getData(indata, 'mood_dnbf', index))

        // console.log(CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msecstamp', index)), ep_seerjf);

        trend = [CLAPI.Utils.getMsecDate(CLAPI.getData(indata, 'msecstamp', index)),
            ep_seerjf, mood_subf,
        ]
        for (let fdi = 0; fdi < ARRAY_FTREND.length; fdi++) {
            // console.log(ARRAY_FTREND[fdi]);
            trend.push(CLAPI.getData(indata, ARRAY_FTREND[fdi], index))
        }
        trends.push(trend)
    }
    return {
        fields: FIELD_FTREND_KBAR,
        datas: trends
    }
}
export const FIELD_KBAR_FWIN = {
    date: 0,
    agop: 1,
    open: 2,
    maxp: 3,
    minp: 4,
    newp: 5,
    sumv: 6,
    summ: 7,
    wave: 8,
    rate: 9,
}

export function curdateToFwin(curdata) {
    const indata = {
        datas: curdata,
        fields: FIELD_KBAR
    }
    const wave = (CLAPI.getData(indata, 'maxp', 0) - CLAPI.getData(indata, 'minp', 0)) / CLAPI.getData(indata, 'minp', 0)
    const rate = (CLAPI.getData(indata, 'newp', 0) - CLAPI.getData(indata, 'agop', 0)) / CLAPI.getData(indata, 'agop', 0)
    let kbars = [
        CLAPI.getData(indata, 'date', 0),
        CLAPI.getData(indata, 'agop', 0),
        CLAPI.getData(indata, 'open', 0),
        CLAPI.getData(indata, 'maxp', 0),
        CLAPI.getData(indata, 'minp', 0),
        CLAPI.getData(indata, 'newp', 0),
        CLAPI.getData(indata, 'sumv', 0),
        CLAPI.getData(indata, 'summ', 0),
        wave, rate
    ]
    return {
        fields: FIELD_KBAR_FWIN,
        datas: kbars
    }
}
export const CHART_KBAR_FWIN = {
    // 浮动窗口特殊标记
    style: 'fwindow',
    // 头信息定义 通常用于需要特殊显示的数据
    header: {
        display: 'text',
        spaceY: 3,
        spaceX: 1,
        rows: [{
            cols: [{
                align: 'left',
                maxchs: 8,
                field: 'date',
                clr: 'code',
                getvar: 'getIntVar',
            }]
        }],
    },
    // 统一表格信息
    boards: {
        upper: {
            display: 'text', // 顶部信息 text 显示label data根据cols取字段信息 line 显示分隔横线 rate 显示百分比图
            spaceX: 3,
            rows: [{
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '昨收',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'agop',
                            clr: 'txt',
                            getvar: 'getFltVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '今开',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'open',
                            subfield: 'agop',
                            getclr: 'getSubClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最高',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'maxp',
                            subfield: 'agop',
                            getclr: 'getSubClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最低',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'minp',
                            subfield: 'agop',
                            getclr: 'getSubClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '最新',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'newp',
                            subfield: 'agop',
                            getclr: 'getSubClr',
                            getvar: 'getPrcVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '涨幅',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'rate',
                            getclr: 'getZeroClr',
                            getvar: 'getPctVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '振幅',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'wave',
                            getclr: 'getFltClr',
                            getvar: 'getPctVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '总量',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'sumv',
                            getclr: 'getVolClr',
                            getvar: 'getVolVar',
                        },
                    ]
                },
                {
                    cols: [{
                            align: 'left',
                            maxchs: 4,
                            label: '总额',
                            clr: 'label',
                        },
                        {
                            maxchs: 7,
                            field: 'summ',
                            getclr: 'getMnyClr',
                            getvar: 'getMnyVar',
                        },
                    ]
                },
            ],
        },
    }
}

export const CHART_KBAR_HEAD = {
    style : 'horizontal',  // 'vertical'
    maxchs : 8,
    ctrls: [{
            clickValue: 'date',
            label: '日',
        },
        {
            clickValue: 'week',
            label: '周',
        },
        {
            clickValue: 'month',
            label: '月',
        },
    ]
}

export const kbar_main_buttons = [{ // 放大
        clickName: 'zoomin',
        drawMethod: 'decr', // 画+号
    },
    { // 缩小 
        clickName: 'zoomout',
        drawMethod: 'incr', // 画-号
    },
    { // 除权
        clickName: 'exright',
        drawMethod: 'text', // 显示文本
        clickInfo: [{
                label: '权',
                value: 'none'
            },
            {
                label: '前',
                value: 'forword'
            },
            // { label : '后', value : 'after' },
        ],
    },
    { // 均线轨道
        clickName: 'maarea',
        drawMethod: 'text', // 显示文本
        clickInfo: [{
                label: '均',
                value: 'ma'
            },
            {
                label: '轨',
                value: 'grade'
            },
            {
                label: '道',
                value: 'area'
            },
        ],
    },
    { // 侧边栏
        clickName: 'chip',
        drawMethod: 'text', // 显示文本
        clickInfo: [{
                label: '筹',
                value: 'chip'
            },
            {
                label: '关',
                value: 'nochip'
            },
        ],
    }
]

export const kbar_main_emap_lines = [{
        className: CLAPI.ClDrawKBar, // 图按ClDrawKBar类来画
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['maxp'], // 参与计算最大值的标签
            minvalue: ['minp'] // 参与计算最小值的标签
        },
        // 第一根线默认的key是跟随chart的hotKey变化而变化的，其他线要么自己有数据，要么根据hotKey加上公式计算出自己的key
    },
    {
        className: CLAPI.ClDrawMark,
        info: {
            drawInfo: 'none',
            color: 'button',
            drawMethod: 'strToMap',
            fieldY: 'right',
        },
    },
    {
        className: CLAPI.ClDrawZLine,
        info: { // 输出在信息栏目（title）的数据
            label: ' 5:',
            fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
            format: 'price'
        },
        formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
            key: 'DAYM1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
            //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
            command: `out = this.MA('newp',5)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '10:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYM2', // 获取数据的key，
            command: `out = this.MA('newp',10)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '20:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYM3', // 获取数据的key，
            command: `out = this.MA('newp',20)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '60:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYM4', // 获取数据的key，
            command: `out = this.MA('newp',60)` // 公式只能输出值到out中
        }
    }
]

export const kbar_main_grade_lines = [{
        className: CLAPI.ClDrawKBar, // 图按ClDrawKBar类来画
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['maxp'], // 参与计算最大值的标签
            minvalue: ['minp'] // 参与计算最小值的标签
        },
        // 第一根线默认的key是跟随chart的hotKey变化而变化的，其他线要么自己有数据，要么根据hotKey加上公式计算出自己的key
    },
    {
        className: CLAPI.ClDrawMark,
        info: {
            drawInfo: 'none',
            color: 'button',
            drawMethod: 'strToMap',
            fieldY: 'right',
        },
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '60:',
            fieldY: 'value',
            format: 'price',
            color: 'lwhite',
        },
        formula: {
            key: 'DAYM1', // 获取数据的key，
            command: `out = this.MA('newp',60)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: { // 输出在信息栏目（title）的数据
            label: ' S1:',
            fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
            format: 'price'
        },
        formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
            key: 'DAYMAS1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
            //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
            command: `out = this.MAAREA('newp', 60, 1)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value']  // 参与计算最小值的标签
        // },
        info: {
            label: 'S2:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMAS2', // 获取数据的key，
            command: `out = this.MAAREA('newp', 60, 2)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value'] // 参与计算最小值的标签
        // },
        info: {
            label: 'S3:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMAS3', // 获取数据的key，
            command: `out = this.MAAREA('newp', 60, 3)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: { // 输出在信息栏目（title）的数据
            label: ' B1:',
            fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
            format: 'price'
        },
        formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
            key: 'DAYMAB1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
            //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
            command: `out = this.MAAREA('newp', 60, -1)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value'] // 参与计算最小值的标签
        // },
        info: {
            label: 'B2:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMAB2', // 获取数据的key，
            command: `out = this.MAAREA('newp', 60, -2)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value']  // 参与计算最小值的标签
        // },
        info: {
            label: 'B3:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMAB3', // 获取数据的key，
            command: `out = this.MAAREA('newp', 60, -3)` // 公式只能输出值到out中
        }
    },
]

export const kbar_main_area_lines = [{
        // type: 'l_kbar',
        className: CLAPI.ClDrawKBar, // 图按ClDrawKBar类来画
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['maxp'], // 参与计算最大值的标签
            minvalue: ['minp'] // 参与计算最小值的标签
        },
    },
    {
        className: CLAPI.ClDrawMark,
        info: {
            drawInfo: 'none',
            color: 'button',
            drawMethod: 'strToMap',
            fieldY: 'right',
        },
    },
    {
        className: CLAPI.ClDrawZLine,
        info: {
            label: '60:',
            fieldY: 'value',
            format: 'price',
            color: 'lwhite',
        },
        formula: {
            key: 'DAYM1', // 获取数据的key，
            command: `out = this.MA('newp',60)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['avgp'], // 参与计算最大值的标签
            minvalue: ['avgp'] // 参与计算最小值的标签
        },
        info: {
            label: 'AVG:',
            fieldY: 'avgp',
            // fieldX: 'date',
            format: 'price'
        },
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: { // 输出在信息栏目（title）的数据
            label: ' S1:',
            fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
            format: 'price'
        },
        formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
            key: 'DAYMS1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
            //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
            command: `out = this.AREA('avgp', 1)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value']  // 参与计算最小值的标签
        // },
        info: {
            label: 'S2:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMS2', // 获取数据的key，
            command: `out = this.AREA('avgp', 2)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value'] // 参与计算最小值的标签
        // },
        info: {
            label: 'S3:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMS3', // 获取数据的key，
            command: `out = this.AREA('avgp', 3)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: { // 输出在信息栏目（title）的数据
            label: ' B1:',
            fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
            format: 'price'
        },
        formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
            key: 'DAYMB1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
            //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
            command: `out = this.AREA('avgp', -1)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value'] // 参与计算最小值的标签
        // },
        info: {
            label: 'B2:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMB2', // 获取数据的key，
            command: `out = this.AREA('avgp', -2)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        // extremum: { // 如何取极值
        //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        //     maxvalue: ['value'], // 参与计算最大值的标签
        //     minvalue: ['value']  // 参与计算最小值的标签
        // },
        info: {
            label: 'B3:',
            fieldY: 'value',
            format: 'price'
        },
        formula: {
            key: 'DAYMB3', // 获取数据的key，
            command: `out = this.AREA('avgp', -3)` // 公式只能输出值到out中
        }
    },
]
export const CHART_KBAR_AREA = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    buttons: kbar_main_buttons,
    scroll: { // 是否显示下方的游标
        display: 'normal' // 'none' does not show normal
    },
    title: { // 标题
        display: 'text', // none does not show btn button text
        label: 'K线' // label information to be displayed
    },
    axisX: {
        display: 'none',
        lines: 0, // 纵向线有几根，不包括两边的框线
        left: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'normal',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 3, // 横向线有几根
        left: { //左边的坐标信息
            display: 'both', // none不显示, both, noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // 输出数据的格式 rate, price 保留一定小数位 vol 没有小数
        },
        right: { //右边的坐标信息
            display: 'both', // none不显示，noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // rate, price vol
        }
    },
    // 下面是当前图形的所有需要画的线，一般非特殊的线，直接通过配置就可以得到想要的效果
    lines: kbar_main_area_lines,
}

export const kbar_main_fbnq_lines = [{
    // type: 'l_kbar',
    className: CLAPI.ClDrawKBar, // 图按ClDrawKBar类来画
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['maxp'], // 参与计算最大值的标签
        minvalue: ['minp'] // 参与计算最小值的标签
    },
},
{
    className: CLAPI.ClDrawMark,
    info: {
        drawInfo: 'none',
        color: 'button',
        drawMethod: 'strToMap',
        fieldY: 'right',
    },
},
{
    className: CLAPI.ClDrawZLine,
    info: {
        label: '60:',
        fieldY: 'value',
        format: 'price',
        color: 'lwhite',
    },
    formula: {
        key: 'DAYM1', // 获取数据的key，
        command: `out = this.MA('newp',60)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['avgp'], // 参与计算最大值的标签
        minvalue: ['avgp'] // 参与计算最小值的标签
    },
    info: {
        label: 'AVG:',
        fieldY: 'avgp',
        // fieldX: 'date',
        format: 'price'
    },
},
{
    className: CLAPI.ClDrawZLine,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['value'], // 参与计算最大值的标签
        minvalue: ['value'] // 参与计算最小值的标签
    },
    info: { // 输出在信息栏目（title）的数据
        label: ' S1:',
        fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
        format: 'price'
    },
    formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
        key: 'DAYMS1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
        //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
        command: `out = this.FBNQ('avgp', 1)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value']  // 参与计算最小值的标签
    // },
    info: {
        label: 'S2:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMS2', // 获取数据的key，
        command: `out = this.FBNQ('avgp', 2)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value'] // 参与计算最小值的标签
    // },
    info: {
        label: 'S3:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMS3', // 获取数据的key，
        command: `out = this.FBNQ('avgp', 3)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['value'], // 参与计算最大值的标签
        minvalue: ['value'] // 参与计算最小值的标签
    },
    info: { // 输出在信息栏目（title）的数据
        label: ' B1:',
        fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
        format: 'price'
    },
    formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
        key: 'DAYMB1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
        //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
        command: `out = this.FBNQ('avgp', -1)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value'] // 参与计算最小值的标签
    // },
    info: {
        label: 'B2:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMB2', // 获取数据的key，
        command: `out = this.FBNQ('avgp', -2)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value']  // 参与计算最小值的标签
    // },
    info: {
        label: 'B3:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMB3', // 获取数据的key，
        command: `out = this.FBNQ('avgp', -3)` // 公式只能输出值到out中
    }
},
]

export const kbar_main_mafbnq_lines = [{
    // type: 'l_kbar',
    className: CLAPI.ClDrawKBar, // 图按ClDrawKBar类来画
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['maxp'], // 参与计算最大值的标签
        minvalue: ['minp'] // 参与计算最小值的标签
    },
},
{
    className: CLAPI.ClDrawMark,
    info: {
        drawInfo: 'none',
        color: 'button',
        drawMethod: 'strToMap',
        fieldY: 'right',
    },
},
{
    className: CLAPI.ClDrawZLine,
    info: {
        label: '60:',
        fieldY: 'value',
        format: 'price',
        color: 'lwhite',
    },
    formula: {
        key: 'DAYM1', // 获取数据的key，
        command: `out = this.MA('newp',60)` // 公式只能输出值到out中
    }
},
// {
//     className: CLAPI.ClDrawZLine,
//     extremum: { // 如何取极值
//         method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
//         maxvalue: ['avgp'], // 参与计算最大值的标签
//         minvalue: ['avgp'] // 参与计算最小值的标签
//     },
//     info: {
//         label: 'AVG:',
//         fieldY: 'avgp',
//         // fieldX: 'date',
//         format: 'price'
//     },
// },
{
    className: CLAPI.ClDrawZLine,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['value'], // 参与计算最大值的标签
        minvalue: ['value'] // 参与计算最小值的标签
    },
    info: { // 输出在信息栏目（title）的数据
        label: ' S1:',
        fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
        format: 'price'
    },
    formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
        key: 'DAYMS1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
        //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
        command: `out = this.MAFBNQ('newp', 60, 4)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value']  // 参与计算最小值的标签
    // },
    info: {
        label: 'S2:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMS2', // 获取数据的key，
        command: `out = this.MAFBNQ('newp', 60, 3)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value'] // 参与计算最小值的标签
    // },
    info: {
        label: 'S3:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMS3', // 获取数据的key，
        command: `out = this.MAFBNQ('newp', 60, 2)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value'] // 参与计算最小值的标签
    // },
    info: {
        label: 'S4:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMS4', // 获取数据的key，
        command: `out = this.MAFBNQ('newp', 60, 1)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    extremum: { // 如何取极值
        method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
        maxvalue: ['value'], // 参与计算最大值的标签
        minvalue: ['value'] // 参与计算最小值的标签
    },
    info: { // 输出在信息栏目（title）的数据
        label: ' B1:',
        fieldY: 'value', // 从key中获取对应的数据标签 用于显示信息用
        format: 'price'
    },
    formula: { // 数据生成方式，都需要基于基本数据，没有formula表示取绑定的数据
        key: 'DAYMB1', // 生成和获取数据的key，必须要定义一个key，否则当你要使用的时候，并不知道取什么样的数据；
        //另外当客户端修改参数或公式时，可以只修改参数和公式，而不修改key，也可以避免垃圾数据过多
        command: `out = this.MAFBNQ('newp', 60, -4)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value'] // 参与计算最小值的标签
    // },
    info: {
        label: 'B2:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMB2', // 获取数据的key，
        command: `out = this.MAFBNQ('newp', 60, -3)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value']  // 参与计算最小值的标签
    // },
    info: {
        label: 'B3:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMB3', // 获取数据的key，
        command: `out = this.MAFBNQ('newp', 60, -2)` // 公式只能输出值到out中
    }
},
{
    className: CLAPI.ClDrawZLine,
    // extremum: { // 如何取极值
    //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //     maxvalue: ['value'], // 参与计算最大值的标签
    //     minvalue: ['value']  // 参与计算最小值的标签
    // },
    info: {
        label: 'B4:',
        fieldY: 'value',
        format: 'price'
    },
    formula: {
        key: 'DAYMB4', // 获取数据的key，
        command: `out = this.MAFBNQ('newp', 60, -1)` // 公式只能输出值到out中
    }
},
]
export const CHART_KBAR_FBNQ = {
    zoomInfo: CLAPI.ChartRes.ZOOM_INFO_DEF,
    buttons: kbar_main_buttons,
    scroll: { // 是否显示下方的游标
        display: 'normal' // 'none' does not show normal
    },
    title: { // 标题
        display: 'text', // none does not show btn button text
        label: 'K线' // label information to be displayed
    },
    axisX: {
        display: 'none',
        lines: 0, // 纵向线有几根，不包括两边的框线
        left: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'normal',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 3, // 横向线有几根
        left: { //左边的坐标信息
            display: 'both', // none不显示, both, noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // 输出数据的格式 rate, price 保留一定小数位 vol 没有小数
        },
        right: { //右边的坐标信息
            display: 'both', // none不显示，noupper 不显示最上面, nofoot不显示最下面 = 显示坐标
            middle: 'none', // 是否有中间值 'before'=前收盘 ‘zero’ 0为中间值
            format: 'price' // rate, price vol
        }
    },
    // 下面是当前图形的所有需要画的线，一般非特殊的线，直接通过配置就可以得到想要的效果
    lines: kbar_main_mafbnq_lines,
}
export const kbar_analy_ddzb_lines = [{
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['sum_bigr5'], // 参与计算最大值的标签
            minvalue: ['sum_bigr5'] // 参与计算最小值的标签
        },
        info: {
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'index',
            fieldY: 'sum_bigr5', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: '5:',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float'
        },
        formula: {
            key: 'BIGMB1', // 获取数据的key，
            command: `out = this.MA('sum_bigr5',5)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: '10:',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float'
        },
        formula: {
            key: 'BIGMB2', // 获取数据的key，
            command: `out = this.MA('sum_bigr5',10)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: '20:',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float'
        },
        formula: {
            key: 'BIGMB3', // 获取数据的key，
            command: `out = this.MA('sum_bigr5',20)` // 公式只能输出值到out中
        }
    },
]

export const CHART_KBAR_DDZB = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '大单占比' // 需要显示的文字信息
    },
    axisX: {
        lines: 0,
        left: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'float'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'float'
        }
    },
    lines: kbar_analy_ddzb_lines
}

export const CHART_KBAR_ZLJM = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '散户持仓' // 需要显示的文字信息
    },
    axisX: {
        lines: 0,
        left: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'float'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'float'
        }
    },
    lines:  [ 
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['dsvrchg'], // 参与计算最大值的标签
                minvalue: ['dsvrchg'] // 参与计算最小值的标签
        },
        info: {
            label: "机构持仓:",
            filled: true,
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'dsvrchg', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['swveer'], // 参与计算最大值的标签
            minvalue: ['swveer'] // 参与计算最小值的标签
        },
        info: {
            label: "机构期望:",
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'swveer', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    ]
}

export const CHART_KBAR_SHCC = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '散户持仓' // 需要显示的文字信息
    },
    axisX: {
        lines: 0,
        left: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'float'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'float'
        }
    },
    lines:  [ 
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['xvolr'], // 参与计算最大值的标签
                minvalue: ['xvolr'] // 参与计算最小值的标签
        },
        info: {
            label: "X:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'xvolr', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['yvolr'], // 参与计算最大值的标签
                minvalue: ['yvolr'] // 参与计算最小值的标签
        },
        info: {
            label: "Y:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'yvolr', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['zvolr'], // 参与计算最大值的标签
                minvalue: ['zvolr'] // 参与计算最小值的标签
        },
        info: {
            label: "Z:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'zvolr', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['dvolr'], // 参与计算最大值的标签
                minvalue: ['dvolr'] // 参与计算最小值的标签
        },
        info: {
            label: "机构持仓:",
            // colorIndex : 10 + wvi,
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'dvolr', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    // {
    //     className: CLAPI.ClDrawVBar,
    //     extremum: { // 如何取极值
    //         method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //         maxvalue: ['xvolr'], // 参与计算最大值的标签
    //         minvalue: ['xvolr'] // 参与计算最小值的标签
    //     },
    //     info: {
    //         filled: true,
    //         label: "机构持仓:",
    //         showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
    //         fieldX: 'date',
    //         fieldY: 'xvolr', // 需要显示的变量，从key中获取对应的数据标签
    //         format: 'float',
    //     }
    // },
    ]
}

export const CHART_KBAR_CCYC = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '预测' // 需要显示的文字信息
    },
    axisX: {
        lines: 0,
        left: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'float'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'float'
        }
    },
    lines:  [  
    // {
    //     className: CLAPI.ClDrawZLine,
    //     extremum: { // 如何取极值
    //             method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
    //             maxvalue: ['swveer'], // 参与计算最大值的标签
    //             minvalue: ['swveer'] // 参与计算最小值的标签
    //     },
    //     info: {
    //         label: "W:",
    //         showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
    //         fieldX: 'date',
    //         fieldY: 'swveer', // 需要显示的变量，从key中获取对应的数据标签
    //         format: 'float',
    //     }
    // },
    {
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['swveer'], // 参与计算最大值的标签
            minvalue: ['swveer'] // 参与计算最小值的标签
        },
        info: {
            label: "W:",
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'date',
            fieldY: 'swveer', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['smveer'], // 参与计算最大值的标签
                minvalue: ['smveer'] // 参与计算最小值的标签
        },
        info: {
            label: "M:",
            showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
            fieldX: 'date',
            fieldY: 'smveer', // 需要显示的变量，从key中获取对应的数据标签
            format: 'float',
        }
    },
    ]
}

export const kbar_analy_ddhj_lines = [{
        className: CLAPI.ClDrawVBar,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['cur_bigm'], // 参与计算最大值的标签
            minvalue: ['cur_bigm'] // 参与计算最小值的标签
        },
        info: {
            showstyle: 'zero', // 'normal' 正常显示bar 'zero' 以0上下显示
            filled: true,
            fieldX: 'index',
            fieldY: 'cur_bigm', // 需要显示的变量，从key中获取对应的数据标签
            format: 'money',
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: '10:',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'money'
        },
        formula: {
            key: 'BIGM1', // 获取数据的key，
            command: `out = this.SUMMA('cur_bigm',10, 5)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: '20:',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'money'
        },
        formula: {
            key: 'BIGM2', // 获取数据的key，
            command: `out = this.SUMMA('cur_bigm',20, 5)` // 公式只能输出值到out中
        }
    },
    {
        className: CLAPI.ClDrawZLine,
        extremum: { // 如何取极值
            method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            maxvalue: ['value'], // 参与计算最大值的标签
            minvalue: ['value'] // 参与计算最小值的标签
        },
        info: {
            label: '30:',
            fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
            format: 'money'
        },
        formula: {
            key: 'BIGM3', // 获取数据的key，
            command: `out = this.SUMMA('cur_bigm',30, 5)` // 公式只能输出值到out中
        }
    },
]
export const CHART_KBAR_DDHJ = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '大单合计' // 需要显示的文字信息
    },
    axisX: {
        lines: 0,
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'money'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'money'
        }
    },
    lines: kbar_analy_ddhj_lines
}

export const CHART_KBAR_RATE = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '涨幅' // 需要显示的文字信息
    },
    axisX: {
        lines: 0,
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'float'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'float'
        }
    },
    lines: [{
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['rate'], // 参与计算最大值的标签
                minvalue: ['rate'] // 参与计算最小值的标签
            },
            info: {
                showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
                filled: true,
                fieldX: 'index',
                fieldY: 'rate', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '5:',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float'
            },
            formula: {
                key: 'RATEM1', // 获取数据的key，
                command: `out = this.MA('rate',5)` // 公式只能输出值到out中
            }
        },
    ]
}

export const CHART_KBAR_SIGNAL = {
    title: {
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '信号' // 需要显示的文字信息
    },
    axisX: {
        lines: 0,
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'chunk',
            getvar: 'XshowTxt', // 从公共 axisXinfo.showTxt 获取
        },
    },
    axisY: {
        lines: 1,
        left: {
            display: 'both',
            middle: 'none',
            format: 'float'
        },
        right: {
            display: 'both',
            middle: 'none',
            format: 'float'
        }
    },
    lines: [{
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: [5], // 参与计算最大值的标签
                minvalue: [0] // 参与计算最小值的标签
            },
            info: {
                showstyle: 'normal', // 'normal' 正常显示bar 'zero' 以0上下显示
                filled: true,
                fieldX: 'index',
                fieldY: 'nums', // 需要显示的变量，从key中获取对应的数据标签
                format: 'vol',
            }
        }
    ]
}
export const CHART_KBAR_MOOD = {
    title: {
        spaceX: 5,
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '情绪', // 需要显示的文字信息
        maxchs: 4,
    },
    axisX: {
        display: 'none',
        lines: 0,
        left: {
            display: 'none', // chunk normal
        },
        right: {
            display: 'none',
        },
        middle: {
            display: 'none',
        },
    },
    axisY: {
        display: 'none',
        lines: 1,
        left: {
            display: 'none',
            middle: 'none',
            format: 'money'
        },
        right: {
            display: 'none',
            middle: 'none',
            format: 'money'
        }
    },
    lines: [{
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            // extremum: { // 如何取极值
            //     method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
            //     maxvalue: ['mood_upbf'], // 参与计算最大值的标签
            //     minvalue: ['mood_upbf'] // 参与计算最小值的标签
            // },
            info: {
                label: 'B',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
                color: 'red',
            },
            formula: {
                key: 'MOODUP', // 获取数据的key，
                command: `out = this.MA('mood_upbf',5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: 'S',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
                color: 'green',
            },
            formula: {
                key: 'MOODDN', // 获取数据的key，
                command: `out = this.MA('mood_dnbf',5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                showstyle: 'zero',
                label: '合',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
                color: 'lwhite',
            },
            formula: {
                key: 'MOODSUM', // 获取数据的key，
                command: `out = this.MA('mood_sumf',5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '差',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
                // color : 'lwhite',
            },
            formula: {
                key: 'MOODSUB', // 获取数据的key，
                command: `out = this.MA('mood_subf',5)` // 公式只能输出值到out中
            }
        },
    ]
}

export const CHART_KBAR_WISH = {
    title: {
        spaceX: 5,
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '期望', // 需要显示的文字信息
        maxchs: 4,
    },
    axisX: {
        display: 'normal',
        lines: 0,
        left: {
            display: 'normal', // chunk normal
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        right: {
            display: 'normal',
            getvar: 'XdataTxt', // 从公共 axisXinfo.dataTxt 获取
        },
        middle: {
            display: 'none',
        },
    },
    axisY: {
        display: 'none',
        lines: 1,
        left: {
            display: 'none',
            middle: 'none',
            format: 'money'
        },
        right: {
            display: 'none',
            middle: 'none',
            format: 'money'
        }
    },
    lines: [{
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '大',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
                color: 'red',
            },
            formula: {
                key: 'WISH1', // 获取数据的key，
                command: `out = this.MA('ep_seejgf',3)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '散',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
                color: 'green',
            },
            formula: {
                key: 'WISH2', // 获取数据的key，
                command: `out = this.MA('ep_seeshf',3)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                showstyle: 'zero',
                label: '合',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
                color: 'lwhite',
            },
            formula: {
                key: 'WISH3', // 获取数据的key，
                command: `out = this.MA('ep_seerzf',3)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '差',
                fieldY: 'value', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float',
                // color : 'lwhite',
            },
            formula: {
                key: 'WISH4', // 获取数据的key，
                command: `out = this.MA('ep_seerjf',3)` // 公式只能输出值到out中
            }
        },
    ]
}

export const CHART_KBAR_EMV = {
    title: {
        spaceX: 5,
        display: 'text', // none 不显示 btn 按钮 text 文字
        label: '能量', // 需要显示的文字信息
        maxchs: 4,
    },
    axisX: {
        display: 'none',
        lines: 0,
        left: {
            display: 'none', // chunk normal
        },
        right: {
            display: 'none',
        },
        middle: {
            display: 'none',
        },
    },
    axisY: {
        display: 'none',
        lines: 1,
        left: {
            display: 'none',
            middle: 'none',
            format: 'money'
        },
        right: {
            display: 'none',
            middle: 'none',
            format: 'money'
        }
    },
    lines: [{
            className: CLAPI.ClDrawVBar,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['emny_summ'], // 参与计算最大值的标签
                minvalue: ['emny_summ'] // 参与计算最小值的标签
            },
            info: {
                showstyle: 'zero',
                label: 'E',
                fieldY: 'emny_summ', // 需要显示的变量，从key中获取对应的数据标签
                format: 'float'
            },
        },
        {
            className: CLAPI.ClDrawZLine,
            extremum: { // 如何取极值
                method: 'normal', // fixedLeft fixedRight 上下固定,此时需要取axisY.middle的定义
                maxvalue: ['value'], // 参与计算最大值的标签
                minvalue: ['value'] // 参与计算最小值的标签
            },
            info: {
                label: '5',
                fieldY: 'value',
                format: 'float'
            },
            formula: {
                key: 'EMA1', // 获取数据的key，
                command: `out = this.MA('emny_summ',5)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            info: {
                label: '10',
                fieldY: 'value',
                format: 'float'
            },
            formula: {
                key: 'EMV2', // 获取数据的key，
                command: `out = this.MA('emny_summ',10)` // 公式只能输出值到out中
            }
        },
        {
            className: CLAPI.ClDrawZLine,
            info: {
                label: '20',
                fieldY: 'value',
                format: 'float'
            },
            formula: {
                key: 'EMV3', // 获取数据的key，
                command: `out = this.MA('emny_summ',20)` // 公式只能输出值到out中
            }
        },
    ]
}

export const analyinfos = [
    {
        analyname : 'DDHJ',
        label: '大单合计',
        lines : CHART_KBAR_DDHJ,
    },
    {
        analyname : 'DDZB',
        label: '大单占比',
        lines : CHART_KBAR_DDZB,
    },
    {
        analyname : 'ZLJM',
        label: '主力揭秘',
        lines : CHART_KBAR_ZLJM,
    },
    {
        analyname : 'SHCC',
        label: '散户持仓',
        lines : CHART_KBAR_SHCC,
    },
    {
        analyname : 'CCYC',
        label: '持仓预测',
        lines : CHART_KBAR_CCYC,
    }
]

export const CHART_ANALY_HEAD = {
    style : 'horizontal',  // 'vertical'
    maxchs : 8,
    ctrls: [{
            clickValue: 'DDHJ',
            label: analyinfos[0].label,
        },
        {
            clickValue: 'DDZB',
            label: analyinfos[1].label,
        },
        {
            clickValue: 'ZLJM',
            label: analyinfos[2].label,
        },
        {
            clickValue: 'SHCC',
            label: analyinfos[3].label,
        },
        {
            clickValue: 'CCYC',
            label: analyinfos[4].label,
        },
    ]
}